
import { required, minLength, maxLength, email, numeric } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import { metaDataMixin } from '~/mixins'

export default {
  mixins: [
    validationMixin,
    metaDataMixin,
  ],
  asyncData ({ store, route }) {
    store.dispatch('breadcrumbs/set', {
      path: route.fullPath,
      width: 6,
      items: [
        {
          to: '/contact',
          label: 'Contact',
        },
        {
          label: 'Mening geven',
        },
      ],
    })
  },
  data () {
    return {
      inputSubject: null,
      inputMood: null,
      inputRelationNumber: null,
      inputOpinion: null,
      inputName: null,
      inputEmail: null,
      inputPhone: null,
      errorMessages: {
        inputSubject: ['geef aan waarover jij je mening wilt geven.'],
        inputRelationNumber: ['vul een correct relatienummer in of laat het leeg.'],
        inputMood: ['kies een emotie die past bij je mening.'],
        inputEmail: ['vul een correct e-mailadres in.'],
        inputName: ['naam is een verplicht veld.'],
        inputPhone: ['vul een correct telefoonnummer in.'],
      },
      seo: {
        title: 'Mening geven',
        description: 'Geef je mening over wat wij doen en maken via het formulier op deze pagina.',
      },
    }
  },
  validations: {
    inputSubject: {
      required,
    },
    inputMood: {
      required,
    },
    inputOpinion: {},
    inputRelationNumber: {
      numeric,
      minLength: minLength(9),
      maxLength: maxLength(9),
    },
    inputName: {
      required,
      minLength: minLength(2),
    },
    inputEmail: {
      required,
      email,
    },
    inputPhone: {
      // Dutch phone number regex from https://regexr.com/3aevr
      validPhone:
        value => /^((\+|00(\s|\s?-\s?)?)31(\s|\s?-\s?)?(\(0\)[-\s]?)?|0)[1-9]((\s|\s?-\s?)?[0-9])((\s|\s?-\s?)?[0-9])((\s|\s?-\s?)?[0-9])\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]$/.test(value) ||
        value === null ||
        value === '',
    },
  },
  computed: {
    compiledDescription () {
      /**
       * Merge multiple fields to one string for the hidden input field 'description'
       */
      return `
        Gevoel:\r
        ${this.inputMood || 'onbekend'}\r
        \r
        Mening:\r
        ${this.inputOpinion || 'onbekend'}
      `
    },
  },
}
